import { Button, Tooltip, Typography, makeStyles } from "@material-ui/core";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { EProcessNames } from "api/enums";
import { lang } from "i18nLang";
import { useRef } from "react";
import { AccessProfileStore, MessageStore } from "store";

const useStyle = makeStyles((theme) => ({
  uploadButton: {
    border: `1px solid ${theme.palette.gray[400]}`,
    padding: theme.spacing(2),
    minWidth: 42,
  },
  icon: {
    transform: "rotate(40deg)",
  },
  label: {
    marginLeft: theme.spacing(1),
  },
  inputFile: {
    display: "none",
  },
}));

interface IUploadButtonProps {
  color?: string;
  showLabel?: boolean;
  onChangeFiles: (files: File[]) => void;
}

const UploadButton = ({
  color,
  showLabel,
  onChangeFiles,
}: IUploadButtonProps) => {
  const classes = useStyle();
  const inputFileRef = useRef<HTMLInputElement>(null);

  const handleClickButton = () => {
    if (
      !AccessProfileStore.validateAccessPermissionTo(
        EProcessNames.ANEXAR_ARQUIVOS
      )
    ) {
      MessageStore.error(lang("userProfile.profileDoesNotAllow"));
      return;
    }
    inputFileRef.current?.click();
  };

  const handleChangeInputFile = (event) => {
    const files = event.target.files;
    onChangeFiles(files);

    if (inputFileRef.current) inputFileRef.current.value = "";
  };

  return (
    <>
      <Tooltip title={lang("attachments.attachFiles")}>
        <Button className={classes.uploadButton} onClick={handleClickButton}>
          <AttachFileIcon
            className={classes.icon}
            style={{ color: color || "unset" }}
          />
          {showLabel && (
            <Typography
              className={classes.label}
              style={{ color: color || "unset" }}
            >
              {lang("attach")}
            </Typography>
          )}
        </Button>
      </Tooltip>
      <input
        ref={inputFileRef}
        type="file"
        multiple
        accept=".xlsx, .docx, .txt, .pdf, .jpg, .jpeg"
        className={classes.inputFile}
        onChange={handleChangeInputFile}
      />
    </>
  );
};

export default UploadButton;
